// TODO: should push backend to return standardized ISO format
export const VINTED_LOCALE_TO_ISO_MAP = {
  cz: 'cs',
  'cz-fr': 'cs',
  'da-fr': 'da-DK',
  de: 'de',
  'de-fr': 'de',
  'el-fr': 'el-GR',
  en: 'en',
  'en-ca-fr': 'en-CA',
  'en-dev': 'en',
  'en-fr': 'en',
  'en-uk': 'en-GB',
  'en-uk-fr': 'en-GB',
  'en-us': 'en-US',
  'en-us-babies': 'en-US',
  'en-us-fr': 'en-US',
  es: 'es',
  'es-fr': 'es',
  'es-us-fr': 'es-US',
  'fi-fr': 'fi-FI',
  fr: 'fr',
  'fr-ca-fr': 'fr-CA',
  'hr-fr': 'hr-HR',
  'hu-fr': 'hu',
  it: 'it',
  'it-fr': 'it',
  lt: 'lt',
  'lt-fr': 'lt',
  nl: 'nl',
  'nl-fr': 'nl',
  pl: 'pl',
  'pl-fr': 'pl',
  'pt-fr': 'pt',
  'ro-fr': 'ro',
  'sk-fr': 'sk',
  'sv-fr': 'sv',
  'sl-fr': 'sl',
  'et-fr': 'et',
  'lv-fr': 'lv',
  keys: 'en',
}

/**
 * Temporary mapping to help with adopting iso-locale in marketplace.
 * The data is obtained from https://localisation.prod.vinted.site/api/v1/locales/mappings as source of truth.
 * The iso_locale array is converted the into map object for instant lookup.
 */
export const VINTED_ISO_LOCALE_MAPPING = {
  'de-fr-AT': 'de-AT',
  'en-fr-AT': 'en-AT',
  'fr-BE': 'fr-BE',
  'en-fr-BE': 'en-BE',
  'es-fr-BE': 'es-BE',
  'nl-fr-BE': 'nl-BE',
  'de-fr-DE': 'de-DE',
  'en-fr-DE': 'en-DE',
  'nl-fr-NL': 'nl-NL',
  'en-fr-NL': 'en-NL',
  'fr-NL': 'fr-NL',
  'es-fr-NL': 'es-NL',
  'sv-fr-SE': 'sv-SE',
  'en-fr-SE': 'en-SE',
  'fi-fr-FI': 'fi-FI',
  'en-fr-FI': 'en-FI',
  'el-fr-GR': 'el-GR',
  'en-fr-GR': 'en-GR',
  'fr-LU': 'fr-LU',
  'en-fr-LU': 'en-LU',
  'es-fr-LU': 'es-LU',
  'nl-fr-LU': 'nl-LU',
  'pl-fr-PL': 'pl-PL',
  'en-fr-PL': 'en-PL',
  'ro-fr-RO': 'ro-RO',
  'en-fr-RO': 'en-RO',
  'sk-fr-SK': 'sk-SK',
  'en-fr-SK': 'en-SK',
  'en-uk-fr-UK': 'en-GB',
  'en-fr-IE': 'en-IE',
  'cz-fr-CZ': 'cs-CZ',
  'en-fr-CZ': 'en-CZ',
  'da-fr-DK': 'da-DK',
  'en-fr-DK': 'en-DK',
  'fr-FR': 'fr-FR',
  'en-fr-FR': 'en-FR',
  'es-fr-FR': 'es-FR',
  'nl-fr-FR': 'nl-FR',
  'hr-fr-HR': 'hr-HR',
  'en-fr-HR': 'en-HR',
  'it-fr-IT': 'it-IT',
  'en-fr-IT': 'en-IT',
  'pt-fr-PT': 'pt-PT',
  'en-fr-PT': 'en-PT',
  'es-fr-ES': 'es-ES',
  'en-fr-ES': 'en-ES',
  'fr-ES': 'fr-ES',
  'nl-fr-ES': 'nl-ES',
  'hu-fr-HU': 'hu-HU',
  'en-fr-HU': 'en-HU',
  'lt-fr-LT': 'lt-LT',
  'en-fr-LT': 'en-LT',
  'en-us-fr-US': 'en-US',
  'es-us-fr-US': 'es-US',
  'en-fr-US': 'en-US',
  'en-fr-UK': 'en-GB',
  'en-fr-EE': 'en-EE',
  'et-fr-EE': 'et-EE',
  'en-fr-SI': 'en-SI',
  'sl-fr-SI': 'sl-SI',
  'en-fr-LV': 'en-LV',
  'lv-fr-LV': 'lv-LV',
}

/* Note: based on ISO 639-1 standard (https://vinted.atlassian.net/wiki/spaces/SWIT/pages/29537107978/ISO+Standards+for+Localization+V2#1.-Language-Standards%3A-ISO-639-1) * */
export enum ISO_LANGUAGE_CODES {
  en = 'en',
  fr = 'fr',
  de = 'de',
  nl = 'nl',
  es = 'es',
  pt = 'pt',
  it = 'it',
  cs = 'cs',
  pl = 'pl',
  sk = 'sk',
  lt = 'lt',
  se = 'se',
  dk = 'dk',
  fi = 'fi',
  hu = 'hu',
  ro = 'ro',
  hr = 'hr',
  el = 'el',
  sl = 'sl',
  lv = 'lv',
  et = 'et',
}

export const DEFAULT_ISO_LANGUAGE_CODE = 'en'
export const DEFAULT_LOCALE = 'en-fr'
